import { Box, useTheme } from '@mui/material';
import { useUpdateOrganization } from '_api/mutations/organizations';
import { OrganizationPayload } from '_api/types';
import { SEVERITY } from '_constants/derived';
import { SecondaryButton } from 'components/atoms';
import { AlertMessage, BaseModal } from 'components/molecules';
import React, { useState } from 'react';
import { FaEdit } from 'react-icons/fa';

import { OrganizationForm } from '../forms';

import { OrganizationModalProps } from './types';

export const OrganizationModal = ({
  organization,
  open,
  onClose,
  isEdit = false,
}: OrganizationModalProps) => {
  const theme = useTheme();
  const { mutateAsync: updateOrganization } = useUpdateOrganization();
  const [editing, setEditing] = useState(isEdit);
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const onSubmit = (updatedOrganization: OrganizationPayload) => {
    updateOrganization(updatedOrganization)
      .then((data) => {
        if (data && data.id) {
          setShowSuccess(true);
          setTimeout(() => onClose(), 1500);
        }
      })
      .catch(() => setShowError(true));
  };

  return (
    <BaseModal
      open={open}
      title={(editing ? 'Edit ' : '') + organization.name}
      onClose={onClose}
    >
      <Box>
        <OrganizationForm
          initValue={organization}
          onSubmit={onSubmit}
          disableAll={showSuccess || !editing}
          hideSubmitButtons={!editing}
        />
        {!editing && (
          <SecondaryButton
            onClick={() => setEditing(true)}
            sx={{
              color: theme.palette.primary.main,
              float: 'right',
            }}
          >
            <span> Edit </span>
            <FaEdit style={{ marginLeft: '5px' }} />
          </SecondaryButton>
        )}
      </Box>
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Successfully Updated Organization'}
      />
      <AlertMessage
        open={showError}
        onClose={() => setShowError(false)}
        severity={SEVERITY.error}
        message={'An Error occurred while updating Organization. Please Try again later.'}
      />
    </BaseModal>
  );
};
